import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { LoaderModule } from '@core/loader/loader.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { SharedModule } from '@shared/shared.module';
import { EquationsModule } from '../equations/equations.module';
import { LiquiditySourceEquationsComponent } from './liquidity-source-equations.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SpreadSheetsModule,
    MatDividerModule,
    MatTreeModule,
    MatIconModule,
    MatProgressSpinnerModule,
    LoaderModule,
    EquationsModule,
    MatTooltipModule
  ],
  declarations: [LiquiditySourceEquationsComponent]
})
export class LiquiditySourceEquationsModule {}
